import { html } from "../base/_utils";

export const staff = [
    // Alicia Borchard
    {
        id: "aliciaBorchard",
        image: "assets/media/pages/about/staff-headshots/alicia-huber-new.webp",
        name: "Alicia Borchard",
        title: "Program Assistant",
        email: "alicia.borchard@northern.edu",
        phone: "605-626-2550",
        bio: html`
            <p>
                Since joining the Foundation team in 2014, Alicia Borchard has overseen multiple projects for the team, including data entry, real estate and scholarship management, work-study
                supervision, donor acknowledgement, and special events. Borchard previously supervised the call center for eight years at Western Printing. She has a husband, Ben, and four children,
                Aubrey, Makenna, Liam, and Lincoln.
            </p>
        `,
    },
    // Becky Mehlhoff
    {
        id: "beckyMehlhoff",
        image: "assets/media/pages/about/staff-headshots/becky-mehlhoff-new.webp",
        name: "Becky Mehlhoff",
        title: "Senior Accountant",
        email: "becky.mehlhoff@northern.edu",
        phone: "605-626-7744",
        bio: html`
            <p>
                Becky Mehlhoff has been a valuable member of the Foundation for 29 years. Mehlhoff's responsibilities include financial reconciliations, database management, pledges and receivables
                management, revenue and expense coding, endowment account management, annual scholarship coordination, donor reporting and special event reporting. She earned a B.S. degree in business
                management from Northern. She and her husband, Monte, have two children, Alyson and Joshua.
            </p>
        `,
    },
    // Rocky Burkett
    {
        id: "rockyBurkett",
        image: "assets/media/pages/about/staff-headshots/rocky-burkett.webp",
        name: "Rocky Burkett",
        title: "Director of Development",
        email: "rocky.burkett@northern.edu",
        phone: "605-626-2681",
        bio: html`
            <p>
                Rocky Burkett joined the Foundation in May 2025 as Director of Development, bringing with him a strong background in leadership, education, and athletics. Prior to this role, Burkett
                served as the head coach of the Northern State University wrestling team for 10 years, where he helped shape a competitive and respected program. His commitment to student success
                extended beyond the wrestling mat, having also worked for eight years with TRIO programs—federal outreach and student services initiatives designed to identify and provide services for
                individuals from disadvantaged backgrounds.
            </p>
            <p>
                With a passion for mentorship and development, Rocky brings a unique blend of coaching experience and educational advocacy to his current role. His deep understanding of student needs
                and institutional advancement positions him as a valuable asset to the Foundation's mission.
            </p>
        `,
    },
    // Laci Hettick
    {
        id: "laciHettick",
        image: "assets/media/pages/about/staff-headshots/laci-hettick-25.webp",
        name: "Laci Hettick",
        title: "Senior Director of Development-<br> Major Gifts & Athletics",
        email: "laci.hettick@northern.edu",
        phone: "605-626-2612",
        bio: html`
            <p>
                Laci Hettick joined the NSU Foundation team in August of 2021. Hettick is responsible for the development and implementation of fundraising programs and revenue opportunities to
                promote financial support for Northern's athletic programs and special projects. Hettick is familiar with NSU athletics, as she was a member of the Wolves' track team from 2008 to
                2010. She earned a bachelor's degree in political science and master's degree in educational studies at Northern.
            </p>
            <p>
                Before joining the Foundation, Hettick spent 10 years working in Northern's Student Success Center. She was an academic advisor, student success coordinator, and director of TRIO
                Student Support Services. She and her husband, Josh, have three children: Josie, Dashiell, and Lila.
            </p>
        `,
    },
    // Lauren Bittner
    {
        id: "laurenBittner",
        image: "assets/media/pages/about/staff-headshots/lauren-bittner-25.webp",
        name: "Lauren Bittner",
        title: "Director of Development",
        email: "lauren.bittner@northern.edu",
        phone: "605-626-2553",
        bio: html`
            <p>
                Lauren Bittner joined the Foundation in 2012 as the coordinator of alumni operations. She has also served as the director of business development for the Aberdeen Development
                Corporation. An Aberdeen native and NSU alum, Bittner has earned a B.S. degree in marketing and management and an MBA with an emphasis in management from the University of Mary. She
                and her husband, Nick, have two children, Lennon and Gavin.
            </p>
        `,
    },
    // Zach Flakus
    {
        id: "zachFlakus",
        image: "assets/media/pages/about/staff-headshots/zach-flakus.webp",
        name: "Zach Flakus",
        title: "President and CEO",
        email: "zach.flakus@northern.edu",
        phone: "605-626-3005",
        bio: html`
            <p>Zach Flakus assumed the role of president and CEO for the Northern State University Foundation in June 2021.</p>
            <p>Flakus is no stranger to Northern, as he has spent more than 20 years at NSU as a student-athlete and dedicated employee.</p>
            <p>
                Most recently, he worked as general manager of Jackrabbit Sport Properties (South Dakota State University) for Learfield/IMG College, in Brookings. Previously, he served as NSU deputy
                director of athletics and director of athletic development/associate athletic director and associate director of alumni services, both for the NSU Foundation.
            </p>
            <p>He and his wife, Amy, have four children: Mattison, Lincoln, Jake, and Sampson.</p>
        `,
    },
    // Kayley Royer
    {
        id: "kayleyRoyer",
        image: "assets/media/pages/about/staff-headshots/kayley-johnson.webp",
        name: "Kayley Royer",
        title: "Director of Alumni Services",
        email: "kayley.royer@northern.edu",
        phone: "605-626-2550",
        bio: html`
            <p>
                Director of Alumni Services, Kayley Royer, joined the NSU Foundation team in March of 2023, and is responsible for planning and implementing programs and projects that engage alumni in
                strengthening and providing tangible benefits to alumni, the university, and current students. Royer, who was previously the Director of the YMCA Youth Development Center, holds a B.S.
                in Education from NSU. She and Wade, NSU Pole Vault coach, live in Aberdeen. Royer has two daughters, Kenley and Kollins.
            </p>
        `,
    },
    // Makayla Pulfrey
    {
        id: "makaylaPulfrey",
        image: "assets/media/pages/about/staff-headshots/makayla-pulfrey-25.webp",
        name: "Makayla Pulfrey",
        title: "Program Assistant-Coordinator of Operations",
        email: "Makayla.r.pulfrey@northern.edu",
        phone: "605-626-2550",
        bio: html`
            <p>
                Makayla Pulfrey joined the NSU Foundation team in March of 2025. She supports the team in fostering relationships with donors and alumni, event planning, and manages the Foundation's
                social media platforms. An Aberdeen native and NSU alum, Pulfrey has earned a bachelor's degree in sports marketing and administration and a master's degree in sport leadership from
                NSU. Before joining the Foundation, Pulfrey previously spent time as a graduate assistant in the Athletics Office and as an Admissions Counselor in the NSU Admissions Office.
            </p>
        `,
    },
    // Reece Ragatz
    {
        id: "reeceRagatz",
        image: "assets/media/pages/about/staff-headshots/reece-ragatz.webp",
        name: "Reece Ragatz",
        title: "Assistant Director of Development, Corporate Partnerships",
        email: "reece.m.ragatz@northern.edu",
        phone: "605-626-2597",
        bio: html`
            <p>
                Reece Ragatz joined the Foundation in June 2025 as the Assistant Director of Development for Corporate Partnerships. A Sioux Falls native with family ties to Aberdeen and NSU alum,
                Ragatz earned a bachelor's degree in Sports Marketing and Administration and a master's degree in Sport Leadership.
            </p>
            <p>
                Ragatz is familiar with NSU athletics and the NSU Foundation, as he was a member of the Wolves' baseball team from 2018 to 2023 and served as the graduate assistant for the Foundation
                while pursuing his master's degree.
            </p>
        `,
    },
    // Jennifer Law
    {
        id: "jenniferLaw",
        image: "assets/media/pages/about/staff-headshots/jennifer-law.webp",
        name: "Jennifer Law",
        title: "Director of Finance",
        email: "jennifer.law@northern.edu",
        phone: "605-626-2030",
        bio: html`
            <p>
                Jennifer Law joined the NSU Foundation team in August of 2025 as the Director of Finance. Law’s responsibilities include overseeing all financial activities, including managing the
                budget and ensuring accuracy of financial information. She earned a Bachelor of Science degree in Accounting from NSU. Before joining the Foundation, Law was the President of
                Kyburz-Carlson Construction.  She and her husband, Mike, have two children, Bryson and Maddison.
            </p>
        `,
    },
];
